<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'DataFilter',
  })
</script>

<template>
  <div class="filter">
    <slot />
  </div>
</template>

<style lang="sass" scoped>
  .filter
    display: inline-block
    width: 100%
    margin-bottom: .5rem

    label
      width: 100%
      display: inline-block
      font-size: .9rem
      margin-top: 5px
      margin-right: .25rem
      margin-bottom: 5px
</style>
